if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      // Laru 2026-10-18: botones «Comprar ahora» y carrito de la barra móvil (delegado: el contenido
      // de la barra se vuelve a dibujar al cambiar de variante).
      this.addEventListener('click', this.handleLaruClick.bind(this));
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // Laru 2026-10-18: en celular y escritorio la barra se muestra siempre que los botones de
      // compra no estén en pantalla (antes solo aparecía después de pasarlos hacia abajo).
      // Descuenta el encabezado fijo: botones tapados por el menú cuentan como fuera de pantalla.
      const header = document.querySelector('.cc-header--sticky');
      const headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      }, { rootMargin: `-${headerHeight}px 0px 0px 0px` });

      if (this.productForm) observer.observe(this.productForm);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    handleLaruClick(evt) {
      const btn = evt.target.closest('[data-laru-satc]');
      if (!btn) return;
      evt.preventDefault();

      const form = this.productSection.querySelector('form.js-product-form-main');
      const addBtn = form && form.querySelector('[name="add"]');
      if (!form || !addBtn || addBtn.disabled) {
        this.productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (btn.dataset.laruSatc === 'add') {
        const onAdded = () => {
          btn.classList.add('laru-satc__cart--added');
          setTimeout(() => btn.classList.remove('laru-satc__cart--added'), 2000);
        };
        this.productSection.addEventListener('on:cart:add', onAdded, { once: true });
        this.productSection.addEventListener('on:line-item:change', onAdded, { once: true });
        addBtn.click();
        return;
      }

      this.buyNow(form, btn);
    }

    /**
     * «Comprar ahora»: agrega la variante elegida (con la cantidad) al carro y va directo al pago.
     * @param {HTMLFormElement} form - Formulario principal del producto.
     * @param {HTMLButtonElement} btn - Botón presionado.
     */
    async buyNow(form, btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!res.ok) throw new Error(`cart/add ${res.status}`);
        window.location.href = `${root}checkout`;
      } catch (err) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        // Si no se pudo (p. ej. sin stock), se usa el botón normal, que muestra el error.
        form.querySelector('[name="add"]').click();
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
